import {Component, Input, OnInit} from '@angular/core';
import {PriebezneHodnotenieGroup} from '../model/PriebezneHodnotenieGroup';
import {PriebezneHodnotenie} from '../model/PriebezneHodnotenie';

@Component({
    selector: 'app-priebezne-hodnotenie-item',
    templateUrl: './priebezne-hodnotenie-item.component.html',
    styleUrls: ['./priebezne-hodnotenie-item.component.css'],
    standalone: false
})
export class PriebezneHodnotenieItemComponent implements OnInit {

  @Input()
  ph: PriebezneHodnotenieGroup;

  suma = 0;

  constructor() { }

  ngOnInit(): void {
    let ziskane = 0;
    let podmieneneDovody = 0;
    let podmieneneZiskaneDovody = 0;

    if (this.ph.items) {
      this.ph.items.forEach((i) => {
          if (i.zapocitat && i.minHranica !== null) {
            podmieneneDovody++;
          }
          if (i.zapocitat && i.pocetBodov !== null) {
            if (i.minHranica === null || i.pocetBodov >= i.minHranica) {
              ziskane += i.pocetBodov < i.hranica ? i.pocetBodov : i.hranica;
              if (i.minHranica !== null) {
                podmieneneZiskaneDovody++;
              }
            }
          }

          this.suma = (podmieneneDovody > podmieneneZiskaneDovody ? 0 : ziskane);
        });
    }


  }

  getHranica(h: PriebezneHodnotenie): string
  {
    let s = '';

    if (h.minHranica) {
      s += 'min. ' + h.minHranica;
    }

    if (h.hranica) {
      s += ' max. ' + h.hranica;
    }

    s = s.trim();

    if (s.length === 0) {
      return '';
    }

    return '(' + s + ')';
  }

  getPocetBodov(h: PriebezneHodnotenie): string {
    if (h.pocetBodov === null) {
      return '';
    }
    return h.pocetBodov.toString().replace('.', ',');
  }

  maMaloBodov(h: PriebezneHodnotenie): boolean {
    if (h.minHranica && h.pocetBodov && h.minHranica > h.pocetBodov) {
      return true;
    }
    return false;
  }

  getPocetBodovSk(suma: number): string {
    return suma.toString().replace('.', ',');
  }

  zapocitavat(items: PriebezneHodnotenie[]) {
    return items.filter(i => i.zapocitat);
  }

  nezapocitavat(items: PriebezneHodnotenie[]) {
    return items.filter(i => !i.zapocitat);
  }
}
